import React from "react";
// reactstrap components
import {
	Collapse,
	DropdownToggle,
	UncontrolledDropdown,
	NavbarBrand,
	Navbar,
	NavItem,
	NavLink,
	Nav,
	Container,
	UncontrolledTooltip,
} from "reactstrap";

function ExamplesNavbar() {
	const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
	const [collapseOpen, setCollapseOpen] = React.useState(false);
	React.useEffect(() => {
		const updateNavbarColor = () => {
			if (
				document.documentElement.scrollTop > 399 ||
				document.body.scrollTop > 399
			) {
				setNavbarColor("");
			} else if (
				document.documentElement.scrollTop < 400 ||
				document.body.scrollTop < 400
			) {
				setNavbarColor("navbar-transparent");
			}
		};
		window.addEventListener("scroll", updateNavbarColor);
		return function cleanup() {
			window.removeEventListener("scroll", updateNavbarColor);
		};
	});
	return (
		<>
			{collapseOpen ? (
				<div
					id="bodyClick"
					onClick={() => {
						document.documentElement.classList.toggle("nav-open");
						setCollapseOpen(false);
					}}
				/>
			) : null}
			<Navbar
				className={"fixed-top " + navbarColor}
				// style={{ background: "#2cc" }}
				color="info"
				expand="lg"
			>
				<Container>
					<UncontrolledDropdown className="button-dropdown">
						<DropdownToggle
							caret
							data-toggle="dropdown"
							href="#pablo"
							id="navbarDropdown"
							tag="a"
							onClick={(e) => e.preventDefault()}
						>
							<span className="button-bar"></span>
							<span className="button-bar"></span>
							<span className="button-bar"></span>
						</DropdownToggle>
					</UncontrolledDropdown>
					<div className="navbar-translate">
						<NavbarBrand href="#" id="navbar-brand">
							tekhin <sub>ver.</sub> 3
						</NavbarBrand>
						<UncontrolledTooltip target="#navbar-brand">
							by Himanshu
						</UncontrolledTooltip>
						<button
							className="navbar-toggler navbar-toggler"
							onClick={() => {
								document.documentElement.classList.toggle("nav-open");
								setCollapseOpen(!collapseOpen);
							}}
							aria-expanded={collapseOpen}
							type="button"
						>
							<span className="navbar-toggler-bar top-bar"></span>
							<span className="navbar-toggler-bar middle-bar"></span>
							<span className="navbar-toggler-bar bottom-bar"></span>
						</button>
					</div>
					<Collapse
						className="justify-content-end"
						isOpen={collapseOpen}
						navbar
					>
						<Nav navbar>
							<NavItem>
								<NavLink href="#">Get In Touch!</NavLink>
							</NavItem>
							<NavItem>
								<NavLink
									href="https://github.com/hyperloo/"
									target="_blank"
									rel="noopener noreferrer"
									id="github-tooltip"
								>
									<i className="fab fa-github"></i>
									<p className="d-lg-none d-xl-none">Github</p>
								</NavLink>
								<UncontrolledTooltip target="#github-tooltip">
									Get in touch on Github
								</UncontrolledTooltip>
							</NavItem>
							<NavItem>
								<NavLink
									href="https://www.linkedin.com/in/himanshu-singh-1b8009176/"
									target="_blank"
									rel="noopener noreferrer"
									id="linkedin-tooltip"
								>
									<i class="fab fa-linkedin-in"></i>
									<p className="d-lg-none d-xl-none">LinkedIn</p>
								</NavLink>
								<UncontrolledTooltip target="#linkedin-tooltip">
									Follow ME on LinkedIn
								</UncontrolledTooltip>
							</NavItem>
							<NavItem>
								<NavLink
									href="mailto:hack.himanshu1024@gmail.com"
									target="_blank"
									rel="noopener noreferrer"
									id="gmail-tooltip"
								>
									<i className="fab far fa-envelope"></i>
									<p className="d-lg-none d-xl-none">G-Mail</p>
								</NavLink>
								<UncontrolledTooltip target="#gmail-tooltip">
									Mail ME on G-Mail
								</UncontrolledTooltip>
							</NavItem>

							<NavItem>
								<NavLink
									href="https://twitter.com/himansh42304464"
									target="_blank"
									rel="noopener noreferrer"
									id="twitter-tooltip"
								>
									<i className="fab fa-twitter"></i>
									<p className="d-lg-none d-xl-none">Twitter</p>
								</NavLink>
								<UncontrolledTooltip target="#twitter-tooltip">
									Follow ME on Twitter
								</UncontrolledTooltip>
							</NavItem>
							<NavItem>
								<NavLink
									href="https://www.facebook.com/profile.php?id=100007333980423"
									target="_blank"
									rel="noopener noreferrer"
									id="facebook-tooltip"
								>
									<i className="fab fa-facebook-square"></i>
									<p className="d-lg-none d-xl-none">Facebook</p>
								</NavLink>
								<UncontrolledTooltip target="#facebook-tooltip">
									Like ME on Facebook
								</UncontrolledTooltip>
							</NavItem>
						</Nav>
					</Collapse>
				</Container>
			</Navbar>
		</>
	);
}

export default ExamplesNavbar;
